import Button from 'react-bootstrap/Button';
import React, { use, useEffect, useState } from 'react';  
import './App.css';
import NavBar from './NavBar';
import { RouterProvider, createHashRouter } from 'react-router-dom';
import { loadMedia, loadPost, loadPosts, checkIfPageExists, loadSponsors, loadPage, loadProjects } from './wpreq';
import { Card, Carousel } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import manifest from './images/manifest';
import '@wordpress/block-library/build-style/style.css';
import NewsLetter from './NewsLetter';
import AlertCardProvider from './AlertCard';

const router = createHashRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hirek/:page",
    element: <News />,
  },
  {
    path: "/hir/:id",
    element: <Article />,
  },
  {
    path: "/rolunk",
    element: <Rolunk />,
  },
  {
    path: "/kapcsolat",
    element: <Contact />,
  },
  {
    path: "/tagfelvetel",
    element: <Tagfelvetel />,
  },
  {
    path: "/hirlevel",
    element: <Hirlevel />,
  },
  {
    path: "/projektek",
    element: <Projektek />,
  },
  {
    path: "*",
    element: <Home />,
  }
]);

function App() {
  return (
    <RouterProvider router={router}></RouterProvider>
  )
}

function PageLoader({ slug }) {

  const [ page, setPage ] = useState("loading")

  useEffect(() => {
    try {
      loadPage(slug, setPage)
    } catch (error) {
      console.error("Error loading page:", error)
      setPage(null)
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  if (page === "loading") {
    return (
      <div style={{ textAlign: 'center' }}>
        <Spinner animation="border" role="status" style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', marginTop: '20vh' }} />
        <p style={{ textAlign: 'center'}}>Oldal betöltése...</p>
      </div>
    )
  }

  if (page === null) {
    return (
      <div>
        <h1 style={{ textAlign: "center"}}>Hiba</h1>
        <p style={{ textAlign: "center"}}>Nem sikerült betölteni az oldalt. Kérjük, próbálja meg később.</p>
      </div>
    )
  }

  return (
    <div>
      <h1 dangerouslySetInnerHTML={{ __html: page.title.rendered }}></h1>
      <div dangerouslySetInnerHTML={{ __html: page.content.rendered }} style={{ textAlign: 'justify' }}></div>
    </div>
  )
}

function Home() {

  const [ sponsors, setSponsors ] = useState(null)
  const [ posts, setPosts] = useState("loading")
  const [ projects, setProjects ] = useState(null)

  useEffect(() => {
    loadSponsors(setSponsors)
    loadPosts(setPosts, 1);
    loadProjects(setProjects);
  //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {
    console.log("Projects loaded:", projects);
  }, [projects]); 


  return (
    <>
      <NavBar />
      <AlertCardProvider />
      <div style={{ marginBottom: 30 }}>
        {
          projects !== null ?
          <ImageSlider projects={projects} /> :
          <Skeleton height={300} style={{ marginTop: 0, marginBottom: 0}} />
        }
        </div>
     <div style={{ margin: "40px auto 40px auto", width: '90%', maxWidth: '1200px'}}>
          {
            posts === "loading" ?
            <>
              <h1 style={{ textAlign: 'left', marginTop: 10, marginLeft: 20 }}>Töltés...</h1>
              <div style={{ height: 10, backgroundColor: '#841618', marginTop: 10, marginBottom: 10, marginLeft: 20, width: '30vw' }}></div>
              <Spinner animation="border" role="status" style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', marginTop: '20vh' }} />
              <p style={{ textAlign: 'center'}}>Hírek betöltése...</p>
            </>
            :
            posts.length === 0 ?
            <>
              <h1 style={{ textAlign: 'left', marginTop: 10, marginLeft: 20 }} onClick={() => window.location.href="/#hirek/1"}>Híreink</h1>
              <div style={{ height: 10, backgroundColor: '#841618', marginTop: 10, marginBottom: 10, marginLeft: 20, width: '30vw' }}></div>
              <p>Nincsenek hírek.</p>
            </>
            :
            <>
              <h1 style={{ textAlign: 'left', marginTop: 10, marginLeft: 20 }} onClick={() => window.location.href="/#hirek/1"}>Híreink</h1>
              <div style={{ height: 10, backgroundColor: '#841618', marginTop: 10, marginBottom: 10, marginLeft: 20, width: '30vw' }}></div>
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
                gap: '20px', 
                margin: 20
              }}>
              {
                posts.slice(0, 3).map((post) => (
                  <ArticleGridItem key={post.id} post={post} />
                ))
              }
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                <Button variant="primary" href="/#hirek/1">Tovább a hírekhez</Button>
              </div>
            </>
          }

        </div>
      <div style={{ margin: "40px auto 40px auto", width: '90%', maxWidth: '1200px' }}>
        <h1 style={{ textAlign: 'left', marginTop: 40, display: "inline", marginLeft: 20 }}>Partnereink</h1>
        <div style={{ height: 10, backgroundColor: '#841618', marginTop: 10, marginBottom: 10, marginLeft: 20, width: '30vw' }}></div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', marginTop: 20, marginBottom: 20 }}>
          { 
            sponsors === null ?
            <Spinner animation="border" role="status" style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', marginTop: '20vh' }} />
            :
            sponsors.length === 0 ?
            <p>Nincsenek partnereink.</p>
            :
            sponsors.map((sponsor) => (
              <a key={sponsor.id} href={sponsor.title.rendered} target="_blank" rel="noreferrer" style={{ margin: 20 }}>
                {
                  sponsor.featured_media !== 0 ?
                  <img 
                    src={sponsor._embedded['wp:featuredmedia'][0].source_url}
                    alt={sponsor.title.rendered} 
                    style={{ maxHeight: '100px', maxWidth: '200px', objectFit: 'contain' }}
                  />
                  :
                  <div style={{ width: '200px', height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center', border: '1px solid #ccc' }}>
                    <span>{sponsor.title.rendered}</span>
                  </div>
                }
              </a>
            ))
          }
        </div>
      </div>
            <div style={{ margin: "40px auto 40px auto", width: '90%', maxWidth: '1200px' }}>
        <h1 style={{ textAlign: 'left', marginTop: 40, display: "inline", marginLeft: 20 }}>Projektjeink</h1>
        <div style={{ height: 10, backgroundColor: '#841618', marginTop: 10, marginBottom: 10, marginLeft: 20, width: '30vw' }}></div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', marginTop: 20, marginBottom: 20 }}>
          { 
            projects === null ?
            <Spinner animation="border" role="status" style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', marginTop: '20vh' }} />
            :
            projects?.length === 0 ?
            <p>Nincsenek projektjeink.</p>
            :
            projects?.map((project) => (
              <>
                {
                  project.featured_media !== 0 ?
                  <img 
                    key={project.id}
                    src={project._embedded['wp:featuredmedia'][0].source_url}
                    alt={project.title.rendered} 
                    style={{ maxHeight: '100px', maxWidth: '200px', objectFit: 'contain' }}
                  />
                  :
                  <div style={{ width: '200px', height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center', border: '1px solid #ccc' }}>
                    <span>{project.title.rendered}</span>
                  </div>
                }
              </>
            ))
          }
        </div>
      </div>
    </>
  );
}

function ImageSlider({projects}) {


  return (
    <div>
      <Carousel style={{ height: '40vh', maxHeight: '500px', minHeight: '300px' }}>
        {manifest.images.map((image, index) => (
          <Carousel.Item key={index}>
            
            <img
              className="d-block w-100"
              src={require(`./images/${image}`)}
              alt={`Slide ${index + 1}`}
              style={{objectFit: 'cover', objectPosition: 'center', height: '40vh', maxHeight: '500px', minHeight: '300px', filter: 'brightness(50%)', backgroundColor: "black"}}
            />
            {
              index === 0 &&
              <Carousel.Caption>
                <h3 style={{ fontSize: '1.8rem', fontWeight: 'bold' }}>Üdvözöljük</h3>
                <p style={{ fontSize: '1.2rem' }}>az AGRYA honlapján</p>
                <Button variant="light" href="/#rolunk" style={{ marginBottom: 20, borderRadius: 2}}>Rólunk</Button>
              </Carousel.Caption>
            }
            {
              index === 1 &&
              <Carousel.Caption>
                <h3 style={{ fontSize: '1.8rem', fontWeight: 'bold' }}>Rendezvényeink</h3>
                <EventSentence />
              </Carousel.Caption>
            }
            {
              index === 2 && 
              <Carousel.Caption>
                <h3 style={{ fontSize: '1.8rem', fontWeight: 'bold', textAlign: "center" }}>Tagfelvétel</h3>
                <p style={{ textAlign: "center"}}>Csatlakozzon az AGRYA-hoz!.</p>
                <Button variant="light" href="/#tagfelvetel" style={{ marginBottom: 20, borderRadius: 2}}>Tagfelvétel</Button>
              </Carousel.Caption>
            }
            {
              index === 3 &&
              <Carousel.Caption>
                <h3 style={{ fontSize: '1.8rem', fontWeight: 'bold' }}>Hírlevél</h3>
                <p>Iratkozzon fel hírlevelünkre, hogy ne maradjon le a legfrissebb híreinkről!</p>
                <Button variant="light" href="/#hirlevel" style={{ marginBottom: 20, borderRadius: 2}}>Hírlevél</Button>
              </Carousel.Caption>
            }
            {
              index >= 4 &&
              <Carousel.Caption>
                <h3 style={{ fontSize: '1.8rem', fontWeight: 'bold', textAlign: "center" }}>Projektjeink</h3>
                <p style={{ textAlign: "center", overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical"}}>Szervezetünk projektjei</p>
                {
                  projects[0] &&
                  <Button variant="light" href={`/#projektek`} style={{ marginBottom: 20, borderRadius: 2}}>Projektek</Button>
                }
              </Carousel.Caption>
            }
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
}

function EventSentence() {
  
  const [ eventNumber, setEventNumber ] = useState(null)
  
  useEffect(() => {
    fetch(process.env.REACT_APP_EVENT_PB_URL + "/api/collections/rendezvenyek/records?page=1&perPage=50&filter=status%3D%22Nyitott%22",
      {
        method: "GET"
      }
    ).then((data) => data.json())
    .then((data) => {
      if (data.totalItems) {
        setEventNumber(data.totalItems)
      } else {
        setEventNumber(0)
      }
    })
  //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (eventNumber === null) {
    return (
      <>
        <p>Jelenleg <Skeleton width={20} /> eseményre lehet jelentkezeni.</p>
        <Button variant="light" href={process.env.REACT_APP_EVENT_PB_FRONTEND_URL} style={{ marginBottom: 20, borderRadius: 2}}>Rendezvények megtekintése</Button>
      </>
    )
  }

  if (eventNumber === 0) {
    return (
      <>
        <p>Jelenleg nincsenek futó rendezvények.</p>
        <Button variant="light" style={{ marginBottom: 20, borderRadius: 2}} disabled>Rendezvények megtekintése</Button>
      </>
    )
  }

  return (
    <>
      <p>Jelenleg {eventNumber} eseményre lehet jelentkezeni.</p>
      <Button variant="light" href={process.env.REACT_APP_EVENT_PB_FRONTEND_URL} style={{ marginBottom: 20, borderRadius: 2}}>Rendezvények megtekintése</Button>
    </>
  )
}


function News() {


  const [ posts, setPosts] = useState("loading")
  const [page, setPage] = useState(null)
  const [nextPagePosts, setNextPagePosts] = useState([])
  const [prevPagePosts, setPrevPagePosts] = useState([])
  const params = window.location.hash.split('/');
  const pageNo = params[params.length - 1];

  const [isThereNextPage, setIsThereNextPage] = useState(false)

  useEffect(() => {
    loadPosts(setPosts, pageNo);
    setPage(parseInt(pageNo) || 1)
  //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (pageNo !== page) {
      loadPosts(setPosts, page);
    }
  //eslint-disable-next-line react-hooks/exhaustive-deps
  }
  , [page]);

  function handleNextPage() {
    if (!isThereNextPage) return;
    window.location.hash = `hirek/${page + 1}`
    setPage(page + 1)
    setPosts(nextPagePosts)
  }

  function  handlePrevPage() {
    if (page > 1) {
      window.location.hash = `hirek/${page - 1}`
      setPage(page - 1)
      setPosts(prevPagePosts)
    }
  }

  useEffect(() => {
    if (page === 0) return;
    checkIfPageExists(setIsThereNextPage, page + 1)
  //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  useEffect(() => {
    console.log("Current page:", page);
    console.log("isThereNextPage changed:", isThereNextPage);
  }, [isThereNextPage]);

  if (posts === "loading") {
    return (
      <>
        <NavBar />
        <div style={{ margin: '40px' }}>
          <h1 style={{ textAlign: 'left', marginTop: 10, marginLeft: 20 }}>Töltés...</h1>
          <div style={{ height: 10, backgroundColor: '#841618', marginTop: 10, marginBottom: 10, marginLeft: 20, width: '30vw' }}></div>
              <Spinner animation="border" role="status" style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', marginTop: '20vh' }} />
              <p style={{ textAlign: 'center'}}>Hírek betöltése...</p>
        </div>
      </>
    )
  }

  return (
    <>
      <NavBar />
      <div style={{ margin: '40px auto 40px auto', width: '90%', maxWidth: '1200px'}}>
        <h1 style={{ textAlign: 'left', marginTop: 10, display: "inline", marginLeft: 20 }}>Híreink</h1>
        <div style={{ height: 10, backgroundColor: '#841618', marginTop: 10, marginBottom: 10, marginLeft: 20, width: '30vw' }}></div>
        {
          posts.map((post) => (
            <ArticleCard key={post.id} post={post} />
          ))
        }
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
          <a onClick={() => handlePrevPage()}><Button variant="primary" disabled={page === 1}>Vissza</Button></a>
          <p style={{ textAlign: "center", marginLeft: 10, marginRight: 10, display: 'inline'}}>{page}. oldal</p>
          <a onClick={() => handleNextPage()}><Button variant="primary" disabled={!isThereNextPage}>Tovább</Button></a>
        </div>
      </div>
    </>
  );
}

function ArticleCard({ post }) {

  const [ imageSrc, setImageSrc ] = useState(null)

  useEffect(() => {
    if (post.featured_media !== 0) {
      loadMedia(post.featured_media, setImageSrc)
    }
  //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <Card style={{ margin: '20px'}}>
      {
        imageSrc && 
        <ImageWithSkeleton src={imageSrc} alt={post.title.rendered} height="300px" />
      }
    
      <Card.Body>
      <Card.Title as="h5" style={{ fontWeight: 'bold' }} dangerouslySetInnerHTML={{ __html: post.title.rendered}}></Card.Title>
      <p style={{ marginBottom: 10 }}>{new Date(post.date).toLocaleDateString('hu-HU')}</p>
      <p dangerouslySetInnerHTML={{ __html: post.excerpt.rendered}}></p>
      <Button variant="primary" href={`/#hir/${post.id}`}>Olvass tovább</Button>
      </Card.Body>
    </Card>
  );
}

function ArticleGridItem({ post }) {

  const [ imageSrc, setImageSrc ] = useState(null)

  useEffect(() => {
    console.log("Loading media for post:", post.id, post.featured_media);
    if (post.featured_media !== 0) {
      loadMedia(post.featured_media, setImageSrc)
    }
  //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card
      style={{ width: "100%", height: "100%", overflow: "hidden", border: "none", boxShadow: "0 6px 20px rgba(0, 0, 0, 0.08)", transition: "transform 0.2s ease, box-shadow 0.2s ease" }}
    >
      {imageSrc && (
        <div
          style={{ width: "100%", height: "220px", backgroundImage: `url(${imageSrc})`, backgroundSize: "cover", backgroundPosition: "center",
          }}
        />
      )}

      <Card.Body
        style={{ backgroundColor: "#f8f9fa", padding: "24px", display: "flex", flexDirection: "column", flexGrow: 1 }}
      >
        <Card.Title
          as="h5"
          style={{
            fontWeight: "700",
            marginBottom: "10px",
            lineHeight: "1.3",
          }}
          dangerouslySetInnerHTML={{ __html: post.title.rendered }}
        />

        <p
          style={{
            marginBottom: "16px",
            fontSize: "0.9rem",
            color: "#6c757d",
          }}
        >
          {new Date(post.date).toLocaleDateString("hu-HU")}
        </p>
        
        <div
          style={{ flexGrow: 1, color: "#444", lineHeight: "1.6", marginBottom: "20px" }}
          dangerouslySetInnerHTML={{ __html: post.excerpt.rendered }}
        />

        <Button
          variant="primary"
          href={`/#hir/${post.id}?fooldal`}
          style={{ alignSelf: "flex-start" }}
        >
          Olvass tovább
        </Button>
      </Card.Body>
    </Card>
  );
}

function ImageWithSkeleton({ src, alt, width = "100%", height = "200px" }) {

  const [hasImageLoaded, setHasImageLoaded] = useState(false)

  function handleImageLoad() {
    setHasImageLoaded(true)
  }

  return (
    <div style={{ width, height, position: 'relative' }}>
      {
        !hasImageLoaded && <Skeleton width={width} height={height} style={{ marginTop: 0, marginBottom: 0}} />
      }
      <img
        src={src}
        alt={alt}
        style={{ display: 'block', width: '100%', height: '100%', objectFit: 'contain' }}
        loading="lazy"
        onLoad={handleImageLoad}
      />
    </div>
  );
};

function Article() {
  
  const [ post, setPost ] = useState("loading")
  const [ imageSrc, setImageSrc ] = useState(null)
  const params = window.location.hash.split('/');
  const id = params[params.length - 1];
  const fromHomePage = window.location.href.includes("fooldal");

  useEffect(() => {
    loadPost(id, (data) => {
      if (data.id) {
        setPost(data)
        if (data.featured_media !== 0) {
          loadMedia(data.featured_media, setImageSrc)
        }
      } else {
        setPost(null)
      }
    })
  //eslint-disable-next-line react-hooks/exhaustive-deps
  }
  , []);

  if (post === "loading") {
    return (
      <>
        <NavBar />
        <div style={{ margin: '40px', width: '90%', maxWidth: '1200px' }}>
              <h1 style={{ textAlign: 'left', marginTop: 10, marginLeft: 20 }}>Töltés...</h1>
              <div style={{ height: 10, backgroundColor: '#841618', marginTop: 10, marginBottom: 10, marginLeft: 20, width: '30vw' }}></div>
              <Spinner animation="border" role="status" style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', marginTop: '20vh' }} />
              <p style={{ textAlign: 'center'}}>Hír betöltése...</p>
              </div>
      </>
    )
  }

  if (post === null) {
    return (
      <>
        <NavBar />
        <div style={{ margin: '40px', width: '90%', maxWidth: '1200px' }}>
          <h1 style={{ textAlign: 'left', marginTop: 10, marginLeft: 20 }}>Hiba</h1>
          <div style={{ height: 10, backgroundColor: '#841618', marginTop: 10, marginBottom: 10, marginLeft: 20, width: '30vw' }}></div>
          <p>Nem sikerült betölteni a hírt. Kérjük, próbálja meg később.</p>
          <button variant="primary" href="#/">Vissza a főoldalra</button>
        </div>
      </>
    )
  }

  return (
    <>
      <NavBar />
      <div style={{ margin: ' 40px auto 40px auto', width: '90%', maxWidth: '1200px' }}>
        <div style={{ marginLeft: 20 }}>
          <h1 style={{ textAlign: 'left', marginTop: 10, display: "inline"}} dangerouslySetInnerHTML={{ __html: post.title.rendered}}></h1>
        </div>
        <div style={{ height: 10, backgroundColor: '#841618', marginTop: 10, marginBottom: 10, marginLeft: 20, width: '30vw' }}></div>
        <p style={{ marginBottom: 10 , marginLeft: 20 }}>{new Date(post.date).toLocaleDateString('hu-HU')}</p>
        {
          imageSrc &&
          <div style={{ marginLeft: 20, marginRight: 20 }}>
            <ImageWithSkeleton src={imageSrc} alt={post.title.rendered} height="400px" />
          </div>
        }
        <div dangerouslySetInnerHTML={{ __html: post.content.rendered}} style={{ marginTop: 20, marginLeft: 20, marginRight: 20, textAlign: 'justify' }}></div>
        <Button variant="primary" href={ fromHomePage ? "/#" : "/#hirek/1"} style={{ marginLeft: 20, marginTop: 10, marginBottom: 30}}>Vissza a hírekhez</Button>
      </div>
    </>
  )
}


function Rolunk() {
  return (
    <>
      <NavBar />
      <div style={{ margin: 'auto', marginTop: 40, width: '90vw', textAlign: 'justify' }}>
        <PageLoader slug="rolunk" />
      </div>
    </>
  )
}


function Contact() {
  return (
    <>
    <NavBar />
    <div style={{ margin: '20px', textAlign: 'center' }}>
      <PageLoader slug="kapcsolat" />
  </div>
  </>
  )
}

function Tagfelvetel() {
  return (
    <>
    <NavBar />
    <div style={{ margin: '20px', textAlign: 'center' }}>
      <PageLoader slug="tagfelvetel" />
  </div>
  </>
  )
}

function Hirlevel() {
  return (
    <>
    <NavBar />
    <div style={{ margin: '20px', textAlign: 'center' }}>
      <NewsLetter />
  </div>
  </>
  )
}

function Projektek() {

  const [ projects, setProjects ] = useState("loading")

  useEffect(() => {
    loadProjects(setProjects)
  //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (projects === "loading") {
    return (
      <>
        <NavBar />
        <div style={{ margin: '40px' }}>
              <h1 style={{ textAlign: 'left', marginTop: 10, marginLeft: 20 }}>Töltés...</h1>
              <div style={{ height: 10, backgroundColor: '#841618', marginTop: 10, marginBottom: 10, marginLeft: 20, width: '30vw' }}></div>
              <Spinner animation="border" role="status" style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', marginTop: '20vh' }} />
              <p style={{ textAlign: 'center'}}>Projektek betöltése...</p>
        </div>
      </>
    )
  }

  if (projects === null || projects.length === 0) {
    return (
      <>
        <NavBar />
        <div style={{ margin: 'auto', marginTop: 40, width: '90vw', textAlign: 'justify' }}>
          <p style={{ textAlign: 'center' }}>Nincsenek elérhető projektek.</p>
        </div>
      </>
    )
  }


  return (
    <>
      <NavBar />
      <div style={{ margin: 'auto', marginTop: 40, width: '90vw', textAlign: 'justify' }}>
        <h1 style={{ textAlign: 'left', marginTop: 10, display: "inline", marginLeft: 20 }}>Projektjeink</h1>
        <div style={{ height: 10, backgroundColor: '#841618', marginTop: 10, marginBottom: 10, marginLeft: 20, width: '30vw' }}></div>
        <div style={{ margin: 20, marginTop: 70 }}>
        {
          projects.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))
        }
        </div>
      </div>
    </>
  )
}

function ProjectCard({ project }) {

  useEffect(() => {
    console.log("Rendering project:", project.featured_media, project);
  }, [project]);
  
  return (
    <div>
      {
        project.featured_media !== 0 ?
          <ImageWithSkeleton
            src={project._embedded['wp:featuredmedia'][0].source_url}
            alt={project.title.rendered}
            height="400px"
          />
          : null
      }
      <h1 style={{ marginTop: "20px" }} dangerouslySetInnerHTML={{ __html: project.title.rendered }} />
      <div dangerouslySetInnerHTML={{ __html: project.content.rendered }} />
      <hr style={{ marginBottom: "40px"}} />
    </div>
  )
}

export default App;

